import { render, staticRenderFns } from "./bindPhoneAuth.vue?vue&type=template&id=323152ec&scoped=true&"
import script from "./bindPhoneAuth.vue?vue&type=script&lang=js&"
export * from "./bindPhoneAuth.vue?vue&type=script&lang=js&"
import style0 from "./bindPhoneAuth.vue?vue&type=style&index=0&id=323152ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323152ec",
  null
  
)

export default component.exports